import React from 'react';

// Custom Error Boundary for when Sentry is disabled
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by SimpleErrorBoundary:', error, errorInfo);
    // Call onError if available
    if (window.gordianInternal?.onError) {
      window.gordianInternal.onError(error);
    }
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || <div>An error has occured</div>;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
